var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('trax-ui-table-with-actions',{attrs:{"id":_vm.id,"titles":_vm.titles,"actions":_vm.actions,"header":"1"}}),_vm._v(" "),_c('trax-ui-toastr',{attrs:{"id":"trax-account-group-toastr","bus":_vm.bus,"passed-label":"1","no-progress":"1"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }